'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Chat = function Chat(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 15 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'chat'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M0 0v11h4v3h1l4-3h6V0H0zm14 10H9l-4 3v-3H1V1h13v9z' }),
        _react2.default.createElement('path', { d: 'M4 3h7v1H4V3zM4 5h7v1H4V5zM4 7h7v1H4V7z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Chat;
//# sourceMappingURL=Chat.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Chat.js